var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1876_4840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#9C64FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5075 11.7931L30.2772 7H18.5917L6 19.6533L18.4925 32.2069L13.7228 37H25.4083L38 24.3467L25.5075 11.7931ZM18.5917 32.1064V18.7437L25.4083 11.8936V25.2563L18.5917 32.1073V32.1064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1876_4840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav_logo.11171ad342f82d03810e6020e56b2de9.svg";